<template>
  <div
    ref="previewContainer"
    class="image-preview"
    :class="{ 'is-hover': isHovered && !isSelected && !disabled, 'is-selected': isSelected && !disabled, 'has-image': uploadedImage, 'is-disabled': disabled }"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    @click="handleSelect"
  >
    <!-- Actions Bar (visible on hover/select) -->
    <div class="actions-bar">
      <div class="actions-left">
        <!-- Title Area -->
        <div v-if="!isTitleEditing" class="title-display">
          <h3 class="image-title" @click="startTitleEdit">{{ imageTitle }}</h3>
          <!--Show edit button when hover or selected-->
          <!-- Original: 
          <ActionButton
            v-if="!disabled && (isHovered || isSelected)"
            text="Edit"
            default-color="#374957"
            hover-text-color="#1E4670"
            pressed-text-color="#1E4670"
            hover-bg-color="rgba(30, 70, 112, 0.08)"
            pressed-bg-color="rgba(30, 70, 112, 0.12)"
            @click.stop="startTitleEdit"
          >
            <template #prefix>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8969 3.16575C19.0892 3.45687 19.0571 3.85248 18.8008 4.10876L9.60845 13.3011C9.51422 13.3954 9.39659 13.4628 9.26766 13.4965L5.43923 14.4965C5.31437 14.5291 5.18566 14.5284 5.06473 14.4976C4.93616 14.4649 4.81639 14.3982 4.71937 14.3011C4.5311 14.1129 4.45676 13.8389 4.52405 13.5813L5.52405 9.75284C5.55351 9.64003 5.60881 9.52861 5.68529 9.44121L14.9117 0.21967C14.9925 0.138906 15.0898 0.0784602 15.1957 0.0416313C15.2742 0.0143243 15.3574 0 15.4421 0C15.641 0 15.8318 0.0790175 15.9724 0.21967L18.8008 3.0481C18.8374 3.08471 18.8695 3.12416 18.8969 3.16575ZM17.2098 3.57843L15.4421 1.81066L6.92391 10.3288L6.29893 12.7216L8.69169 12.0966L17.2098 3.57843Z" fill="#374957"/>
                <path d="M17.0834 14.9103C17.3568 12.5727 17.4438 10.2188 17.3444 7.87079C17.3397 7.75837 17.3819 7.64898 17.4615 7.56942L18.4448 6.58609C18.5657 6.46519 18.7723 6.54194 18.7836 6.71254C18.9685 9.50219 18.8984 12.3045 18.5733 15.0846C18.3367 17.1071 16.7124 18.6921 14.7003 18.917C11.2338 19.3044 7.65042 19.3044 4.18385 18.917C2.17179 18.6921 0.547457 17.1071 0.310903 15.0846C-0.103634 11.5403 -0.103635 7.95973 0.310903 4.41543C0.547456 2.3929 2.17179 0.807889 4.18385 0.583012C6.8136 0.289099 9.51054 0.218149 12.1727 0.370161C12.3443 0.379958 12.4225 0.587575 12.301 0.709093L11.3084 1.70165C11.2298 1.78034 11.1218 1.82261 11.0106 1.81885C8.78419 1.74376 6.54263 1.82872 4.35046 2.07373C3.02035 2.22239 1.95486 3.272 1.80075 4.58968C1.39975 8.01821 1.39975 11.4818 1.80075 14.9103C1.95486 16.228 3.02035 17.2776 4.35046 17.4263C7.70631 17.8013 11.1779 17.8013 14.5337 17.4263C15.8638 17.2776 16.9293 16.228 17.0834 14.9103Z" fill="#374957"/>
              </svg>
            </template>
          </ActionButton>
          -->
          <FoldableButton
            v-if="!disabled && (isHovered || isSelected)"
            text="Edit"
            built_in_theme="default"
            @click.stop="startTitleEdit"
          >
            <template #prefix>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8969 3.16575C19.0892 3.45687 19.0571 3.85248 18.8008 4.10876L9.60845 13.3011C9.51422 13.3954 9.39659 13.4628 9.26766 13.4965L5.43923 14.4965C5.31437 14.5291 5.18566 14.5284 5.06473 14.4976C4.93616 14.4649 4.81639 14.3982 4.71937 14.3011C4.5311 14.1129 4.45676 13.8389 4.52405 13.5813L5.52405 9.75284C5.55351 9.64003 5.60881 9.52861 5.68529 9.44121L14.9117 0.21967C14.9925 0.138906 15.0898 0.0784602 15.1957 0.0416313C15.2742 0.0143243 15.3574 0 15.4421 0C15.641 0 15.8318 0.0790175 15.9724 0.21967L18.8008 3.0481C18.8374 3.08471 18.8695 3.12416 18.8969 3.16575ZM17.2098 3.57843L15.4421 1.81066L6.92391 10.3288L6.29893 12.7216L8.69169 12.0966L17.2098 3.57843Z" fill="#374957"/>
                <path d="M17.0834 14.9103C17.3568 12.5727 17.4438 10.2188 17.3444 7.87079C17.3397 7.75837 17.3819 7.64898 17.4615 7.56942L18.4448 6.58609C18.5657 6.46519 18.7723 6.54194 18.7836 6.71254C18.9685 9.50219 18.8984 12.3045 18.5733 15.0846C18.3367 17.1071 16.7124 18.6921 14.7003 18.917C11.2338 19.3044 7.65042 19.3044 4.18385 18.917C2.17179 18.6921 0.547457 17.1071 0.310903 15.0846C-0.103634 11.5403 -0.103635 7.95973 0.310903 4.41543C0.547456 2.3929 2.17179 0.807889 4.18385 0.583012C6.8136 0.289099 9.51054 0.218149 12.1727 0.370161C12.3443 0.379958 12.4225 0.587575 12.301 0.709093L11.3084 1.70165C11.2298 1.78034 11.1218 1.82261 11.0106 1.81885C8.78419 1.74376 6.54263 1.82872 4.35046 2.07373C3.02035 2.22239 1.95486 3.272 1.80075 4.58968C1.39975 8.01821 1.39975 11.4818 1.80075 14.9103C1.95486 16.228 3.02035 17.2776 4.35046 17.4263C7.70631 17.8013 11.1779 17.8013 14.5337 17.4263C15.8638 17.2776 16.9293 16.228 17.0834 14.9103Z" fill="#374957"/>
              </svg>
            </template>
          </FoldableButton>
          <!-- MAPPABLE_TYPES is defined in store getter and gotten from selectableMixin.js -->
          <!-- Original: 
          <ActionButton
            v-if="MAPPABLE_TYPES.includes(currentElementType)"
            text="Automate Field"
            default-color="#374957"
            hover-text-color="#1E4670"
            pressed-text-color="#1E4670"
            hover-bg-color="rgba(30, 70, 112, 0.08)"
            pressed-bg-color="rgba(30, 70, 112, 0.12)"
            @click.stop="handleAutoMapping"
          >
            <template #prefix>
              <svg v-if="element.data.mapping" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M3.33317 10V15V5.00001V10ZM11.6665 17.5C11.9026 17.5 12.1005 17.4201 12.2603 17.2604C12.42 17.1007 12.4998 16.9028 12.4998 16.6667C12.4998 16.4306 12.42 16.2326 12.2603 16.0729C12.1005 15.9132 11.9026 15.8333 11.6665 15.8333C11.4304 15.8333 11.2325 15.9132 11.0728 16.0729C10.913 16.2326 10.8332 16.4306 10.8332 16.6667C10.8332 16.9028 10.913 17.1007 11.0728 17.2604C11.2325 17.4201 11.4304 17.5 11.6665 17.5ZM16.6665 9.16668C16.9026 9.16668 17.1005 9.08682 17.2603 8.92709C17.42 8.76737 17.4998 8.56945 17.4998 8.33334C17.4998 8.09723 17.42 7.89932 17.2603 7.73959C17.1005 7.57987 16.9026 7.50001 16.6665 7.50001C16.4304 7.50001 16.2325 7.57987 16.0728 7.73959C15.913 7.89932 15.8332 8.09723 15.8332 8.33334C15.8332 8.56945 15.913 8.76737 16.0728 8.92709C16.2325 9.08682 16.4304 9.16668 16.6665 9.16668ZM4.99984 9.16668H9.1665V7.50001H4.99984V9.16668ZM4.99984 12.5H9.1665V10.8333H4.99984V12.5ZM3.33317 16.6667C2.87484 16.6667 2.48248 16.5035 2.15609 16.1771C1.8297 15.8507 1.6665 15.4583 1.6665 15V5.00001C1.6665 4.54168 1.8297 4.14932 2.15609 3.82293C2.48248 3.49654 2.87484 3.33334 3.33317 3.33334H16.6665C17.1248 3.33334 17.5172 3.49654 17.8436 3.82293C18.17 4.14932 18.3332 4.54168 18.3332 5.00001H3.33317V15H7.49984V16.6667H3.33317ZM9.89567 18.4375C9.40956 17.9514 9.1665 17.3611 9.1665 16.6667C9.1665 16.125 9.32275 15.6389 9.63525 15.2083C9.94775 14.7778 10.3471 14.4792 10.8332 14.3125V11.6667H15.8332V10.6875C15.3471 10.5208 14.9478 10.2222 14.6353 9.79168C14.3228 9.36112 14.1665 8.87501 14.1665 8.33334C14.1665 7.6389 14.4096 7.04862 14.8957 6.56251C15.3818 6.0764 15.9721 5.83334 16.6665 5.83334C17.3609 5.83334 17.9512 6.0764 18.4373 6.56251C18.9234 7.04862 19.1665 7.6389 19.1665 8.33334C19.1665 8.87501 19.0103 9.36112 18.6978 9.79168C18.3853 10.2222 17.9859 10.5208 17.4998 10.6875V13.3333H12.4998V14.3125C12.9859 14.4792 13.3853 14.7778 13.6978 15.2083C14.0103 15.6389 14.1665 16.125 14.1665 16.6667C14.1665 17.3611 13.9234 17.9514 13.4373 18.4375C12.9512 18.9236 12.3609 19.1667 11.6665 19.1667C10.9721 19.1667 10.3818 18.9236 9.89567 18.4375Z" fill="#1E4670"/>
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M3.33317 10V15V5.00004V10ZM11.6665 17.5C11.9026 17.5 12.1005 17.4202 12.2603 17.2605C12.42 17.1007 12.4998 16.9028 12.4998 16.6667C12.4998 16.4306 12.42 16.2327 12.2603 16.073C12.1005 15.9132 11.9026 15.8334 11.6665 15.8334C11.4304 15.8334 11.2325 15.9132 11.0728 16.073C10.913 16.2327 10.8332 16.4306 10.8332 16.6667C10.8332 16.9028 10.913 17.1007 11.0728 17.2605C11.2325 17.4202 11.4304 17.5 11.6665 17.5ZM16.6665 9.16671C16.9026 9.16671 17.1005 9.08685 17.2603 8.92712C17.42 8.7674 17.4998 8.56948 17.4998 8.33337C17.4998 8.09726 17.42 7.89935 17.2603 7.73962C17.1005 7.5799 16.9026 7.50004 16.6665 7.50004C16.4304 7.50004 16.2325 7.5799 16.0728 7.73962C15.913 7.89935 15.8332 8.09726 15.8332 8.33337C15.8332 8.56948 15.913 8.7674 16.0728 8.92712C16.2325 9.08685 16.4304 9.16671 16.6665 9.16671ZM4.99984 9.16671H9.1665V7.50004H4.99984V9.16671ZM4.99984 12.5H9.1665V10.8334H4.99984V12.5ZM3.33317 16.6667C2.87484 16.6667 2.48248 16.5035 2.15609 16.1771C1.8297 15.8507 1.6665 15.4584 1.6665 15V5.00004C1.6665 4.54171 1.8297 4.14935 2.15609 3.82296C2.48248 3.49657 2.87484 3.33337 3.33317 3.33337H16.6665C17.1248 3.33337 17.5172 3.49657 17.8436 3.82296C18.17 4.14935 18.3332 4.54171 18.3332 5.00004H3.33317V15H7.49984V16.6667H3.33317ZM9.89567 18.4375C9.40956 17.9514 9.1665 17.3612 9.1665 16.6667C9.1665 16.125 9.32275 15.6389 9.63525 15.2084C9.94775 14.7778 10.3471 14.4792 10.8332 14.3125V11.6667H15.8332V10.6875C15.3471 10.5209 14.9478 10.2223 14.6353 9.79171C14.3228 9.36115 14.1665 8.87504 14.1665 8.33337C14.1665 7.63893 14.4096 7.04865 14.8957 6.56254C15.3818 6.07643 15.9721 5.83337 16.6665 5.83337C17.3609 5.83337 17.9512 6.07643 18.4373 6.56254C18.9234 7.04865 19.1665 7.63893 19.1665 8.33337C19.1665 8.87504 19.0103 9.36115 18.6978 9.79171C18.3853 10.2223 17.9859 10.5209 17.4998 10.6875V13.3334H12.4998V14.3125C12.9859 14.4792 13.3853 14.7778 13.6978 15.2084C14.0103 15.6389 14.1665 16.125 14.1665 16.6667C14.1665 17.3612 13.9234 17.9514 13.4373 18.4375C12.9512 18.9237 12.3609 19.1667 11.6665 19.1667C10.9721 19.1667 10.3818 18.9237 9.89567 18.4375Z" fill="#C4C4C4"/>
              </svg>
            </template>
          </ActionButton>
          -->
          <FoldableButton
            v-if="MAPPABLE_TYPES.includes(currentElementType)"
            text="Automate Field"
            built_in_theme="default"
            @click.stop="handleAutoMapping"
          >
            <template #prefix>
              <svg v-if="element.data.mapping" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M3.33317 10V15V5.00001V10ZM11.6665 17.5C11.9026 17.5 12.1005 17.4201 12.2603 17.2604C12.42 17.1007 12.4998 16.9028 12.4998 16.6667C12.4998 16.4306 12.42 16.2326 12.2603 16.0729C12.1005 15.9132 11.9026 15.8333 11.6665 15.8333C11.4304 15.8333 11.2325 15.9132 11.0728 16.0729C10.913 16.2326 10.8332 16.4306 10.8332 16.6667C10.8332 16.9028 10.913 17.1007 11.0728 17.2604C11.2325 17.4201 11.4304 17.5 11.6665 17.5ZM16.6665 9.16668C16.9026 9.16668 17.1005 9.08682 17.2603 8.92709C17.42 8.76737 17.4998 8.56945 17.4998 8.33334C17.4998 8.09723 17.42 7.89932 17.2603 7.73959C17.1005 7.57987 16.9026 7.50001 16.6665 7.50001C16.4304 7.50001 16.2325 7.57987 16.0728 7.73959C15.913 7.89932 15.8332 8.09723 15.8332 8.33334C15.8332 8.56945 15.913 8.76737 16.0728 8.92709C16.2325 9.08682 16.4304 9.16668 16.6665 9.16668ZM4.99984 9.16668H9.1665V7.50001H4.99984V9.16668ZM4.99984 12.5H9.1665V10.8333H4.99984V12.5ZM3.33317 16.6667C2.87484 16.6667 2.48248 16.5035 2.15609 16.1771C1.8297 15.8507 1.6665 15.4583 1.6665 15V5.00001C1.6665 4.54168 1.8297 4.14932 2.15609 3.82293C2.48248 3.49654 2.87484 3.33334 3.33317 3.33334H16.6665C17.1248 3.33334 17.5172 3.49654 17.8436 3.82293C18.17 4.14932 18.3332 4.54168 18.3332 5.00001H3.33317V15H7.49984V16.6667H3.33317ZM9.89567 18.4375C9.40956 17.9514 9.1665 17.3611 9.1665 16.6667C9.1665 16.125 9.32275 15.6389 9.63525 15.2083C9.94775 14.7778 10.3471 14.4792 10.8332 14.3125V11.6667H15.8332V10.6875C15.3471 10.5208 14.9478 10.2222 14.6353 9.79168C14.3228 9.36112 14.1665 8.87501 14.1665 8.33334C14.1665 7.6389 14.4096 7.04862 14.8957 6.56251C15.3818 6.0764 15.9721 5.83334 16.6665 5.83334C17.3609 5.83334 17.9512 6.0764 18.4373 6.56251C18.9234 7.04862 19.1665 7.6389 19.1665 8.33334C19.1665 8.87501 19.0103 9.36112 18.6978 9.79168C18.3853 10.2222 17.9859 10.5208 17.4998 10.6875V13.3333H12.4998V14.3125C12.9859 14.4792 13.3853 14.7778 13.6978 15.2083C14.0103 15.6389 14.1665 16.125 14.1665 16.6667C14.1665 17.3611 13.9234 17.9514 13.4373 18.4375C12.9512 18.9236 12.3609 19.1667 11.6665 19.1667C10.9721 19.1667 10.3818 18.9236 9.89567 18.4375Z" fill="#1E4670"/>
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M3.33317 10V15V5.00004V10ZM11.6665 17.5C11.9026 17.5 12.1005 17.4202 12.2603 17.2605C12.42 17.1007 12.4998 16.9028 12.4998 16.6667C12.4998 16.4306 12.42 16.2327 12.2603 16.073C12.1005 15.9132 11.9026 15.8334 11.6665 15.8334C11.4304 15.8334 11.2325 15.9132 11.0728 16.073C10.913 16.2327 10.8332 16.4306 10.8332 16.6667C10.8332 16.9028 10.913 17.1007 11.0728 17.2605C11.2325 17.4202 11.4304 17.5 11.6665 17.5ZM16.6665 9.16671C16.9026 9.16671 17.1005 9.08685 17.2603 8.92712C17.42 8.7674 17.4998 8.56948 17.4998 8.33337C17.4998 8.09726 17.42 7.89935 17.2603 7.73962C17.1005 7.5799 16.9026 7.50004 16.6665 7.50004C16.4304 7.50004 16.2325 7.5799 16.0728 7.73962C15.913 7.89935 15.8332 8.09726 15.8332 8.33337C15.8332 8.56948 15.913 8.7674 16.0728 8.92712C16.2325 9.08685 16.4304 9.16671 16.6665 9.16671ZM4.99984 9.16671H9.1665V7.50004H4.99984V9.16671ZM4.99984 12.5H9.1665V10.8334H4.99984V12.5ZM3.33317 16.6667C2.87484 16.6667 2.48248 16.5035 2.15609 16.1771C1.8297 15.8507 1.6665 15.4584 1.6665 15V5.00004C1.6665 4.54171 1.8297 4.14935 2.15609 3.82296C2.48248 3.49657 2.87484 3.33337 3.33317 3.33337H16.6665C17.1248 3.33337 17.5172 3.49657 17.8436 3.82296C18.17 4.14935 18.3332 4.54171 18.3332 5.00004H3.33317V15H7.49984V16.6667H3.33317ZM9.89567 18.4375C9.40956 17.9514 9.1665 17.3612 9.1665 16.6667C9.1665 16.125 9.32275 15.6389 9.63525 15.2084C9.94775 14.7778 10.3471 14.4792 10.8332 14.3125V11.6667H15.8332V10.6875C15.3471 10.5209 14.9478 10.2223 14.6353 9.79171C14.3228 9.36115 14.1665 8.87504 14.1665 8.33337C14.1665 7.63893 14.4096 7.04865 14.8957 6.56254C15.3818 6.07643 15.9721 5.83337 16.6665 5.83337C17.3609 5.83337 17.9512 6.07643 18.4373 6.56254C18.9234 7.04865 19.1665 7.63893 19.1665 8.33337C19.1665 8.87504 19.0103 9.36115 18.6978 9.79171C18.3853 10.2223 17.9859 10.5209 17.4998 10.6875V13.3334H12.4998V14.3125C12.9859 14.4792 13.3853 14.7778 13.6978 15.2084C14.0103 15.6389 14.1665 16.125 14.1665 16.6667C14.1665 17.3612 13.9234 17.9514 13.4373 18.4375C12.9512 18.9237 12.3609 19.1667 11.6665 19.1667C10.9721 19.1667 10.3818 18.9237 9.89567 18.4375Z" fill="#C4C4C4"/>
              </svg>
            </template>
          </FoldableButton>
        </div>
        <div v-else class="title-edit-container">
          <input
            ref="titleInput"
            v-model="imageTitle"
            placeholder="Image"
            class="title-edit-input"
            @keyup.enter="saveTitleEdit"
            @keyup.esc="cancelTitleEdit"
            @click.stop
          />
          <TextButton
            @click.stop="saveTitleEdit"
          >
            <template #prefix>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M6.75012 12.1275L3.62262 9L2.55762 10.0575L6.75012 14.25L15.7501 5.25L14.6926 4.1925L6.75012 12.1275Z" fill="#1F1F1F"/>
              </svg>
            </template>
            Save
          </TextButton>
        </div>
      </div>
      <!-- Element Selector and Delete Button -->
      <div class="actions-right">
        <SingleSelectorWithSectionalDropdown
          v-if="!isTitleEditing && (isHovered || isSelected)"
          :current-element-type="currentElementType"
          :categories="elementCategories"
          @element-selected="handleElementSelected"
        />
        <!-- Original: 
        <ActionButton
          v-if="isHovered || isSelected"
          text="Delete"
          default-color="#D10000"
          hover-text-color="#F63B3B"
          pressed-text-color="#A60B0B"
          hover-bg-color="rgba(209, 0, 0, 0.08)"
          pressed-bg-color="rgba(209, 0, 0, 0.12)"
          @click.stop="$emit('delete')"
        >
          <template #prefix>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0V1H16V3H15V16C15 17.1 14.1 18 13 18H3C1.9 18 1 17.1 1 16V3H0V1H5V0H11ZM3 16H13V3H3V16ZM5 5H7V14H5V5ZM11 5H9V14H11V5Z" fill="currentColor"/>
            </svg>
          </template>
        </ActionButton>
        -->
        <FoldableButton
          v-if="isHovered || isSelected"
          text="Delete"
          built_in_theme="red"
          @click.stop="$emit('delete')"
        >
          <template #prefix>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0V1H16V3H15V16C15 17.1 14.1 18 13 18H3C1.9 18 1 17.1 1 16V3H0V1H5V0H11ZM3 16H13V3H3V16ZM5 5H7V14H5V5ZM11 5H9V14H11V5Z" fill="currentColor"/>
            </svg>
          </template>
        </FoldableButton>
      </div>
    </div>

    <!-- Image Info Text -->
    <div v-if="!uploadedImage" class="image-description">
      Max file size is xxx kb. Supported file types are xxx, xxx, xxx.
    </div>

    <!-- Image Upload/Display Area -->
    <div v-if="!uploadedImage" class="image-upload-area">
      <div class="upload-content">
        <div class="upload-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
            <rect width="48" height="48" rx="5" fill="#E0E0E0"/>
            <path d="M38 26H26V38H22V26H10V22H22V10H26V22H38V26Z" fill="#8D8D8D"/>
          </svg>
        </div>
        <div class="upload-text">
          <span class="drag-text">Drag and drop your image here to add.</span>
          <span class="or-text">OR</span>
        </div>
        <div @click.stop>
          <!-- Original:
          <Button type="round" colorType="dark-blue" @click="triggerFileUpload" :disabled="disabled">Add File</Button>
          -->
          <ResponsiveButton
            display_name="Add File"
            button_type="filled"
            built_in_theme="dark"
            size="small"
            :disabled="disabled"
            @click-button="triggerFileUpload"
            button_border_radius="100px"
          />
        </div>
        <input
          ref="fileInput"
          type="file"
          accept="image/*"
          style="display: none;"
          @change="handleFileUpload"
        />
      </div>
    </div>
    <div v-else class="image-display-area">
      <div class="image-container">
        <img :src="uploadedImageUrl" alt="Uploaded image" class="uploaded-image" />
        <div v-if="isHovered || isSelected" class="image-overlay">
          <div class="image-overlay-actions">
            <!-- Original:
            <button class="delete-image-btn" @click.stop="handleDeleteImage">
              Delete Image
            </button>
            -->
            <ResponsiveButton
              display_name="Delete Image"
              button_type="outlined"
              built_in_theme="dark"
              size="small"
              @click-button="handleDeleteImage"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Description Area -->
    <div v-if="!isDescriptionEditing" class="description-row">
      <span v-if="description" class="description-text">{{ description }}</span>
      <span v-else class="description-placeholder">Add a description or help text ...</span>
      <!-- Original: 
      <ActionButton
        v-if="!description && (isHovered || isSelected)"
        text="Add Text"
        default-color="#374957"
        hover-text-color="#1E4670"
        pressed-text-color="#1E4670"
        hover-bg-color="rgba(30, 70, 112, 0.08)"
        pressed-bg-color="rgba(30, 70, 112, 0.12)"
        @click.stop="startDescriptionEdit"
      >
        <template #prefix>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M15.8333 10.8333H10.8333V15.8333H9.16666V10.8333H4.16666V9.16667H9.16666V4.16667H10.8333V9.16667H15.8333V10.8333Z" fill="#374957"/>
          </svg>
        </template>
      </ActionButton>
      -->
      <FoldableButton
        v-if="!description && (isHovered || isSelected)"
        text="Add Text"
        built_in_theme="default"
        @click.stop="startDescriptionEdit"
      >
        <template #prefix>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M15.8333 10.8333H10.8333V15.8333H9.16666V10.8333H4.16666V9.16667H9.16666V4.16667H10.8333V9.16667H15.8333V10.8333Z" fill="#374957"/>
          </svg>
        </template>
      </FoldableButton>
      <!-- Original: 
      <ActionButton
        v-else-if="description && (isHovered || isSelected)"
        text="Edit"
        default-color="#374957"
        hover-text-color="#1E4670"
        pressed-text-color="#1E4670"
        hover-bg-color="rgba(30, 70, 112, 0.08)"
        pressed-bg-color="rgba(30, 70, 112, 0.12)"
        @click.stop="startDescriptionEdit"
      >
        <template #prefix>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8969 3.16575C19.0892 3.45687 19.0571 3.85248 18.8008 4.10876L9.60845 13.3011C9.51422 13.3954 9.39659 13.4628 9.26766 13.4965L5.43923 14.4965C5.31437 14.5291 5.18566 14.5284 5.06473 14.4976C4.93616 14.4649 4.81639 14.3982 4.71937 14.3011C4.5311 14.1129 4.45676 13.8389 4.52405 13.5813L5.52405 9.75284C5.55351 9.64003 5.60881 9.52861 5.68529 9.44121L14.9117 0.21967C14.9925 0.138906 15.0898 0.0784602 15.1957 0.0416313C15.2742 0.0143243 15.3574 0 15.4421 0C15.641 0 15.8318 0.0790175 15.9724 0.21967L18.8008 3.0481C18.8374 3.08471 18.8695 3.12416 18.8969 3.16575ZM17.2098 3.57843L15.4421 1.81066L6.92391 10.3288L6.29893 12.7216L8.69169 12.0966L17.2098 3.57843Z" fill="#374957"/>
            <path d="M17.0834 14.9103C17.3568 12.5727 17.4438 10.2188 17.3444 7.87079C17.3397 7.75837 17.3819 7.64898 17.4615 7.56942L18.4448 6.58609C18.5657 6.46519 18.7723 6.54194 18.7836 6.71254C18.9685 9.50219 18.8984 12.3045 18.5733 15.0846C18.3367 17.1071 16.7124 18.6921 14.7003 18.917C11.2338 19.3044 7.65042 19.3044 4.18385 18.917C2.17179 18.6921 0.547457 17.1071 0.310903 15.0846C-0.103634 11.5403 -0.103635 7.95973 0.310903 4.41543C0.547456 2.3929 2.17179 0.807889 4.18385 0.583012C6.8136 0.289099 9.51054 0.218149 12.1727 0.370161C12.3443 0.379958 12.4225 0.587575 12.301 0.709093L11.3084 1.70165C11.2298 1.78034 11.1218 1.82261 11.0106 1.81885C8.78419 1.74376 6.54263 1.82872 4.35046 2.07373C3.02035 2.22239 1.95486 3.272 1.80075 4.58968C1.39975 8.01821 1.39975 11.4818 1.80075 14.9103C1.95486 16.228 3.02035 17.2776 4.35046 17.4263C7.70631 17.8013 11.1779 17.8013 14.5337 17.4263C15.8638 17.2776 16.9293 16.228 17.0834 14.9103Z" fill="#374957"/>
          </svg>
        </template>
      </ActionButton>
      -->
      <FoldableButton
        v-else-if="description && (isHovered || isSelected)"
        text="Edit"
        built_in_theme="default"
        @click.stop="startDescriptionEdit"
      >
        <template #prefix>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8969 3.16575C19.0892 3.45687 19.0571 3.85248 18.8008 4.10876L9.60845 13.3011C9.51422 13.3954 9.39659 13.4628 9.26766 13.4965L5.43923 14.4965C5.31437 14.5291 5.18566 14.5284 5.06473 14.4976C4.93616 14.4649 4.81639 14.3982 4.71937 14.3011C4.5311 14.1129 4.45676 13.8389 4.52405 13.5813L5.52405 9.75284C5.55351 9.64003 5.60881 9.52861 5.68529 9.44121L14.9117 0.21967C14.9925 0.138906 15.0898 0.0784602 15.1957 0.0416313C15.2742 0.0143243 15.3574 0 15.4421 0C15.641 0 15.8318 0.0790175 15.9724 0.21967L18.8008 3.0481C18.8374 3.08471 18.8695 3.12416 18.8969 3.16575ZM17.2098 3.57843L15.4421 1.81066L6.92391 10.3288L6.29893 12.7216L8.69169 12.0966L17.2098 3.57843Z" fill="#374957"/>
            <path d="M17.0834 14.9103C17.3568 12.5727 17.4438 10.2188 17.3444 7.87079C17.3397 7.75837 17.3819 7.64898 17.4615 7.56942L18.4448 6.58609C18.5657 6.46519 18.7723 6.54194 18.7836 6.71254C18.9685 9.50219 18.8984 12.3045 18.5733 15.0846C18.3367 17.1071 16.7124 18.6921 14.7003 18.917C11.2338 19.3044 7.65042 19.3044 4.18385 18.917C2.17179 18.6921 0.547457 17.1071 0.310903 15.0846C-0.103634 11.5403 -0.103635 7.95973 0.310903 4.41543C0.547456 2.3929 2.17179 0.807889 4.18385 0.583012C6.8136 0.289099 9.51054 0.218149 12.1727 0.370161C12.3443 0.379958 12.4225 0.587575 12.301 0.709093L11.3084 1.70165C11.2298 1.78034 11.1218 1.82261 11.0106 1.81885C8.78419 1.74376 6.54263 1.82872 4.35046 2.07373C3.02035 2.22239 1.95486 3.272 1.80075 4.58968C1.39975 8.01821 1.39975 11.4818 1.80075 14.9103C1.95486 16.228 3.02035 17.2776 4.35046 17.4263C7.70631 17.8013 11.1779 17.8013 14.5337 17.4263C15.8638 17.2776 16.9293 16.228 17.0834 14.9103Z" fill="#374957"/>
          </svg>
        </template>
      </FoldableButton>
    </div>
    <div v-else class="description-edit-container">
      <div class="description-textarea-wrapper">
        <textarea
          ref="descriptionTextarea"
          v-model="description"
          class="description-textarea"
          placeholder="Add a description or help text to explain the section. This text is optional but will be visible to the patients ..."
          maxlength="1000"
          @keyup.enter="saveDescription"
          @keyup.esc="cancelDescriptionEdit"
          @click.stop
        ></textarea>
        <div class="description-footer">
          <span class="char-counter">{{ description.length }}/1000 characters</span>
          <TextButton
            @click.stop="saveDescription"
          >
            <template #prefix>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M6.75012 12.1275L3.62262 9L2.55762 10.0575L6.75012 14.25L15.7501 5.25L14.6926 4.1925L6.75012 12.1275Z" fill="#1F1F1F"/>
              </svg>
            </template>
            Save
          </TextButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Original: import Button from '@/NewLibrary/Button.vue';
// Replaced with globally registered ResponsiveButton from @vibrant-wellness/va-responsive-components-library
import { elementSections } from '../elementsData';
import SingleSelectorWithSectionalDropdown from '@/views/commonComponents/SingleSelectorWithSectionalDropdown.vue';
// Original: import ActionButton from '@/views/commonComponents/ActionButton.vue';
// Replaced with globally registered FoldableButton from @vibrant-wellness/va-responsive-components-library
import TextButton from '@/views/commonComponents/TextButton.vue';
import selectableMixin from './mixins/selectableMixin';
import { isEdge } from '@vue-flow/core';

export default {
  name: 'ImagePreview',
  components: {
    // Button, // replaced by globally registered ResponsiveButton
    SingleSelectorWithSectionalDropdown,
    // ActionButton, // replaced by globally registered FoldableButton
    TextButton
  },
  mixins: [selectableMixin],
  emits: [
    'element-type-changed', 
    'delete', 
    'element-selected', 
    'element-deselected', 
    'update-element-data', 
    'auto-mapping',
    'element-edit-state-changed'
  ],
  props: {
    element: {
      type: Object,
      default: () => ({})
    },
    selectedPreviewId: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const elemData = (this.element && this.element.data) || {};
    return {
      imageTitle: elemData.label,
      uploadedImage: elemData.imageFile,
      currentElementType: this.element.type,
      description: elemData.description,
      isDescriptionEditing: false,
      isTitleEditing: false,
      // Initialize with the existing image file ID if available
      imageFileId: elemData.imageFileId
    };
  },
  computed: {
    uploadedImageUrl() {
      return this.uploadedImage ? URL.createObjectURL(this.uploadedImage) : null;
    },
    elementCategories() {
      return [
        {
          name: 'layout',
          label: 'Layout Elements',
          elements: elementSections.layout.elements
        },
        {
          name: 'textInputs',
          label: 'Text Inputs',
          elements: elementSections.textInputs.elements
        },
        {
          name: 'contactInfo',
          label: 'Contact Info',
          elements: elementSections.contactInfo.elements
        },
        {
          name: 'selectionInputs',
          label: 'Selection Inputs',
          elements: elementSections.selectionInputs.elements
        },
        {
          name: 'specializedInputs',
          label: 'Specialized Inputs',
          elements: elementSections.specializedInputs.elements
        }
      ];
    },
    isElementEditing() {
      return this.isTitleEditing || this.isDescriptionEditing;
    }
  },
  watch: {
    isElementEditing(newVal) {
      // pass the edit state to parent
      this.$emit('element-edit-state-changed', {
        id: this.element.id,
        isEditing: newVal
      });
    },
    selectedPreviewId(newVal) {
      if (newVal !== this.element.id) {
        if (this.isSelected) {
          this.isSelected = false;
        }
      }
    },
    isSelected(newVal) {
      if (newVal && this.element && this.element.id) {
        this.$emit('element-selected', this.element.id);
      }else if(!newVal && this.element && this.element.id){
        if(this.isTitleEditing){
          this.saveTitleEdit();
        }
        if(this.isDescriptionEditing){
          this.saveDescription();
        }
        this.$emit('element-deselected', this.element.id);
      }
    }
  },
  methods: {
    handleMouseEnter() {
      if (!this.disabled) {
        this.isHovered = true;
      }
    },
    handleMouseLeave() {
      this.isHovered = false;
    },
    handleSelect() {
      if (this.disabled) {
        return;
      }
      if (!this.isSelected) {
        // this.triggerDeselectOthers();
        this.isSelected = true;
      }
    },
    handleAutoMapping(){
      this.isSelected = true;
      this.$emit('auto-mapping', this.element.id);
    },
    triggerFileUpload() {
      this.$refs.fileInput?.click();
    },
    handleFileUpload(event) {
      const file = event.target.files?.[0];
      this.uploadedImage = file;
      this.imageFileId = null;
      this.emitDataUpdate();
    },
    handleDeleteImage() {
      this.uploadedImage = null;
      this.imageFileId = null;
      this.emitDataUpdate();
    },
    startTitleEdit() {
      if (this.disabled) {
        return;
      }
      this.isSelected = true;
      this.isTitleEditing = true;
      this.$nextTick(() => {
        this.$refs.titleInput?.focus();
        this.$refs.titleInput?.select();
      });
    },
    saveTitleEdit() {
      this.isTitleEditing = false;
      this.emitDataUpdate();
    },
    cancelTitleEdit() {
      const elemData = (this.element && this.element.data) || {};
      this.imageTitle = elemData.label;
      this.isTitleEditing = false;
    },
    startDescriptionEdit() {
      if (this.disabled) {
        return;
      }
      // this.triggerDeselectOthers();
      this.isSelected = true;
      this.isDescriptionEditing = true;
      this.$nextTick(() => {
        this.$refs.descriptionTextarea?.focus();
        this.$refs.descriptionTextarea?.select();
      });
    },
    saveDescription() {
      this.isDescriptionEditing = false;
      this.emitDataUpdate();
    },
    cancelDescriptionEdit() {
      const elemData = (this.element && this.element.data) || {};
      this.description = elemData.description;
      this.isDescriptionEditing = false;
    },
    handleElementSelected(element) {
      this.currentElementType = element.type;
      this.$emit('element-type-changed', element);
    },
    emitDataUpdate() {
      const newData = {
        label: this.imageTitle,
        description: this.description,
        imageFile: this.uploadedImage,
        imageFileId: this.imageFileId
      }
      this.$emit('update-element-data', newData);
    }
  }
};
</script>

<style scoped>
.image-preview {
  width: 100%;
  background: #F9FBFD;
  padding: 24px;
  border-radius: 5px;
  border: 1px solid transparent;
  transition: border-color 0.2s;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.image-preview.is-hover {
  border-color: #004879;
}

.image-preview.is-selected {
  border: 2px solid #004879;
}
.image-preview.has-image{
  gap: 16px;
}

/* Header */
.image-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.image-title {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #333;
  margin: 0;
  cursor: pointer;
}

.title-display {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.title-edit-container {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  background: white;
  border: 1px solid #C4C4C4;
  border-radius: 4px;
  padding: 0 4px;
  height: 26px;
}

.title-edit-input {
  flex: 1;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.15px;
  color: #333;
  border: none;
  background: transparent;
  padding: 0;
  outline: none;
}

.title-edit-input::placeholder {
  color: #666;
}

/* Actions Bar */
.actions-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
}

.actions-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.actions-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Description */
.image-description {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #979797;
}

/* Upload Area */
.image-upload-area {
  background: #F2F2F2;
  border: 2px dashed #C4C4C4;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.upload-icon {
  width: 48px;
  height: 48px;
}

.upload-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.drag-text,
.or-text {
  white-space:nowrap;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #979797;
}

/* Image Display */
.image-display-area {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 12px;
}
.has-image .image-display-area {
  gap: 16px;
}

.image-container {
  position: relative;
  width: 400px;
  height: 400px;
  border-radius: 5px;
  overflow: hidden;
}

.uploaded-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-image-btn {
  background: white;
  color: #1E4670;
  font-family: 'IBM Plex Sans Hebrew', 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.25px;
  padding: 4px 32px;
  border: 1px solid #1E4670;
  border-radius: 15px;
  cursor: pointer;
  box-shadow: 0px 1px 3px 0px rgba(74, 74, 74, 0.25);
}

.delete-image-btn:hover {
  background: #F5F5F5;
}

/* Description Row */
.description-placeholder,
.description-row {
  height: fit-content;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
  min-height: 26px;
  width: 100%;
}

.description-placeholder {
  width: fit-content;
  max-width: 100%;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 4px 0;
  cursor: pointer;
}

.description-text {
  width: fit-content;
  max-width: 100%;
  height: fit-content;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  color: #333;
  padding: 4px 0px;
  white-space: pre-wrap;
  word-break: break-word;
}

/* Description Editing */
.description-edit-container {
  width: 100%;
}

.description-textarea-wrapper {
  border: 1px solid #C9C9C9;
  border-radius: 4px;
  padding: 8px 12px;
  background: white;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.description-textarea {
  width: 100%;
  min-height: 60px;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.15px;
  color: #333;
  border: none;
  outline: none;
  resize: vertical;
  background: transparent;
}

.description-textarea::placeholder {
  color: #999;
}

.description-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
}

.char-counter {
  flex: 1;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #999;
}

:deep(.text-button) {
  padding: 1px 6px;
}
</style>
